/**
 * A knock: true on the `count`th tap in a row, each within `gapMs` of the last.
 *
 * It keeps the developer tools out of a player's way and within the owner's
 * reach (ADR-0048), the way a phone hides its own behind taps on the build
 * number. A slower tap starts the count again; after a knock, so does the next.
 */
export function knock(count: number, gapMs: number): (nowMs: number) => boolean {
  let taps = 0;
  let last = Number.NEGATIVE_INFINITY;
  return (nowMs) => {
    taps = nowMs - last <= gapMs ? taps + 1 : 1;
    last = nowMs;
    if (taps < count) return false;
    taps = 0;
    last = Number.NEGATIVE_INFINITY;
    return true;
  };
}
